import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4477874d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outpaint-edit" }
const _hoisted_2 = { class: "outpaint-edit__settings" }
const _hoisted_3 = { class: "outpaint-edit__settings__title" }
const _hoisted_4 = { class: "outpaint-edit__settings__content" }
const _hoisted_5 = { class: "outpaint-edit__settings__sizes" }
const _hoisted_6 = { class: "outpaint-edit__settings__sizes__item__icon" }
const _hoisted_7 = { class: "outpaint-edit__settings__sizes__item__text" }
const _hoisted_8 = { class: "outpaint-edit__settings__sizes__item__value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "outpaint-edit__divider" }, "×", -1))
const _hoisted_10 = {
  style: {"position":"relative","width":"100%"},
  class: "d-flex align-center"
}
const _hoisted_11 = { class: "outpaint-edit__settings__sizes__item__icon" }
const _hoisted_12 = { class: "outpaint-edit__settings__sizes__item__text" }
const _hoisted_13 = { class: "outpaint-edit__settings__sizes__item__value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "outpaint-edit__divider" }, "×", -1))
const _hoisted_15 = { class: "outpaint-edit__workarea" }
const _hoisted_16 = { class: "outpaint-edit__canvas" }
const _hoisted_17 = { class: "outpaint-edit__canvas-box" }
const _hoisted_18 = { class: "outpaint-edit__canvas__zoom" }
const _hoisted_19 = { class: "outpaint-edit__workarea__data" }
const _hoisted_20 = { class: "outpaint-edit__workarea__actions" }

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import i18n from '@/plugins/i18n';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import { ICanvasImage } from '@/types/ICanvasImage';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCanvas from '@/components/UI/AiCanvas/AiCanvas.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiLocked from '@/components/UI/AiLocked/AiLocked.vue';
import AiSceleton from '@/components/UI/AiSceleton/AiSceleton.vue';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

import { sizesRu } from '@/data/outpaintSizes/sizesRu';
import { sizesEn } from '@/data/outpaintSizes/sizesEn';

interface ICanvasData {
  activeProductId?: string;
  activeProductUid?: string;
  image: string;
  mask: string;
  products: ICanvasImage[];
}

interface ImageData {
  id: string;
  image: string;
  mask: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Outpaint',
  setup(__props) {

const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const { imageForActions, imageResult } = storeToRefs(useServicesStore());

const key = ref<number>(0);
const loading = ref<boolean>(false);
const generationLoading = ref<boolean>(false);
const sizeIndex = ref<number>(0);
const customWidth = ref<number>(512);
const customHeight = ref<number>(512);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const activeZoom = ref<number>(1);
const imageData = ref<ImageData[]>([]);
const canvasWidth = ref<number>(600);
const canvasHeight = ref<number>(600);
const aiCanvasRef = ref<any>(null);
const canvasData = ref<ICanvasData>({
  image: '',
  mask: '',
  products: [],
});
const isEdit = ref<boolean>(false);

const lang = computed(() => i18n.global.locale.value);
// const imageSize = computed(() => getBase64Size(imageForActions.value));
const sizesList = computed(() => (lang.value === 'ru' ? sizesRu : sizesEn));

const outpaintFileHandler = (): void => {
  generationLoading.value = true;
  if (aiCanvasRef.value) {
    aiCanvasRef.value.canvasUpdateData();
    generateImage({
      action: 'outpaint',
      image: removeBase64Prefix(imageForActions.value),
      params: {
        size: {
          height: canvasHeight.value,
          width: canvasWidth.value,
        },
        transform: canvasData.value.products[0].transform,
      },
    })
      .then(async (res) => {
        const bg = await aiCanvasRef.value.getBackground();
        // imagePrev.value = imageForActions.value;
        // imageForActions.value = bg.enlargedBase64src;
        imageForActions.value = bg.enlargedBase64src;
        imageResult.value = `data:image/jpeg;base64,${res.image}`;
      })
      .catch((e) => {
        busError.emit(e?.message || t('common.err-gen'));
      })
      .finally(() => {
        generationLoading.value = false;
      });
  }
};

const zoomInHandler = (): void => {
  activeZoom.value += 0.1;
};

const zoomOutHandler = (): void => {
  activeZoom.value -= 0.1;
};

const activeZoomSetHandler = (newVal: number): void => {
  activeZoom.value = newVal;
};

const setSize = (index: number): void => {
  sizeIndex.value = index;
  if (index === -1) {
    canvasWidth.value = customWidth.value > 512 ? 512 : customWidth.value;
    canvasHeight.value = customHeight.value > 512 ? 512 : customHeight.value;
  } else {
    canvasWidth.value = sizesList.value[index].width;
    canvasHeight.value = sizesList.value[index].height;
  }
};

const canvasUpdateHandler = (data: any): void => {
  canvasData.value = data;
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
    };
    img.src = imageForActions.value;
    key.value += 1;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  if (imageForActions.value !== '') {
    imageData.value = [
      {
        id: 'outpaint',
        image: imageForActions.value,
        mask: false,
      },
    ];
  }
  imageSizeHandler();
  setSize(0);
});

watch(imageForActions, () => {
  if (imageForActions.value !== '') {
    imageData.value = [
      {
        id: 'outpaint',
        image: imageForActions.value,
        mask: false,
      },
    ];
  }
  imageSizeHandler();
});

watch(customHeight, (newVal) => {
  customHeight.value = newVal > 512 ? 512 : newVal;
  canvasHeight.value = newVal;
});

watch(customWidth, (newVal) => {
  customWidth.value = newVal > 512 ? 512 : newVal;
  canvasWidth.value = newVal;
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, { key: 0 }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["service__container outpaint", { 'service__container--mobile': _unref(isMobile) }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (isEdit.value)
              ? (_openBlock(), _createBlock(ImageFinetune, {
                  key: 0,
                  class: "outpaint-edit__finetune",
                  src: _unref(imageForActions),
                  onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                  onSave: editHandler,
                  actions: ['reset', 'save']
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.canvas-size')), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizesList.value, (size, index) => {
                          return (_openBlock(), _createBlock(AiClearButton, {
                            key: index,
                            class: _normalizeClass(["outpaint-edit__settings__sizes__item", { 'outpaint-edit__settings__sizes__item--active': sizeIndex.value === index }]),
                            onClick: ($event: any) => (size.width > 512 || size.height > 512 ? null : setSize(index))
                          }, {
                            default: _withCtx(() => [
                              (size.width > 512 || size.height > 512)
                                ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_6, [
                                (size.width > size.height)
                                  ? (_openBlock(), _createBlock(_component_inline_svg, {
                                      key: 0,
                                      class: "fill",
                                      src: require('@/assets/icons/sizes/horisontal.svg')
                                    }, null, 8, ["src"]))
                                  : (size.width < size.height)
                                    ? (_openBlock(), _createBlock(_component_inline_svg, {
                                        key: 1,
                                        class: "fill",
                                        src: require('@/assets/icons/sizes/vertical.svg')
                                      }, null, 8, ["src"]))
                                    : (_openBlock(), _createBlock(_component_inline_svg, {
                                        key: 2,
                                        class: "fill",
                                        src: require('@/assets/icons/sizes/square.svg')
                                      }, null, 8, ["src"]))
                              ]),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(size.name), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_8, [
                                _createTextVNode(_toDisplayString(size.width) + " ", 1),
                                _hoisted_9,
                                _createTextVNode(" " + _toDisplayString(size.height), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128)),
                        _createVNode(AiClearButton, {
                          class: _normalizeClass(["outpaint-edit__settings__sizes__item", { 'outpaint-edit__settings__sizes__item--active': sizeIndex.value === -1 }]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (setSize(-1)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_inline_svg, {
                                  class: "stroke",
                                  src: require('@/assets/icons/sizes/custom.svg')
                                }, null, 8, ["src"])
                              ]),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('editor.settings.custom')), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: customWidth.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customWidth).value = $event)),
                                  modelModifiers: { number: true, lazy: true },
                                  class: "outpaint-edit__input",
                                  "hide-details": "",
                                  height: "18"
                                }, null, 8, ["modelValue"]),
                                _hoisted_14,
                                _createVNode(_component_v_text_field, {
                                  modelValue: customHeight.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customHeight).value = $event)),
                                  modelModifiers: { number: true, lazy: true },
                                  class: "outpaint-edit__input",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      (_unref(isMobile))
                        ? (_openBlock(), _createBlock(AiButton, {
                            key: 0,
                            disabled: generationLoading.value,
                            theme: "gradient-primary",
                            onClick: outpaintFileHandler,
                            class: "outpaint-edit__settings__button"
                          }, {
                            default: _withCtx(() => [
                              (!generationLoading.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('outpaint.outpaint')), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(AiCard, {
                      radius: 16,
                      class: "outpaint-edit__workarea__card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            (loading.value)
                              ? (_openBlock(), _createBlock(AiSceleton, {
                                  key: 0,
                                  class: "outpaint-edit__canvas__sceleton"
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(AiClearButton, {
                                class: "outpaint-edit__canvas__zoom__button",
                                "active-zoom": activeZoom.value,
                                onClick: zoomOutHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_inline_svg, {
                                    src: require('@/assets/icons/IconDecrease.svg')
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              }, 8, ["active-zoom"]),
                              _createVNode(AiClearButton, {
                                class: "outpaint-edit__canvas__zoom__button",
                                onClick: zoomInHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_inline_svg, {
                                    src: require('@/assets/icons/IconIncrease.svg')
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            (!loading.value)
                              ? (_openBlock(), _createBlock(AiCanvas, {
                                  key: key.value,
                                  "active-zoom": activeZoom.value,
                                  images: imageData.value,
                                  width: canvasWidth.value,
                                  height: canvasHeight.value,
                                  "show-controls": false,
                                  ref_key: "aiCanvasRef",
                                  ref: aiCanvasRef,
                                  onActiveZoomSet: activeZoomSetHandler,
                                  onCanvasUpdate: canvasUpdateHandler
                                }, null, 8, ["active-zoom", "images", "width", "height"]))
                              : _createCommentVNode("", true),
                            (generationLoading.value)
                              ? (_openBlock(), _createBlock(AiDropLoader, { key: 2 }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_v_spacer),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (isEdit.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.correction')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => {
                  imageForActions.value = '';
                  imageResult.value = '';
                })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                              ]),
                              _: 1
                            }),
                            (!_unref(isMobile))
                              ? (_openBlock(), _createBlock(AiButton, {
                                  key: 0,
                                  disabled: generationLoading.value,
                                  theme: "gradient-primary",
                                  class: "outpaint-edit__workarea__button",
                                  onClick: outpaintFileHandler
                                }, {
                                  default: _withCtx(() => [
                                    (!generationLoading.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('outpaint.outpaint')), 1)
                                        ], 64))
                                      : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
          ])
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})